import type { Role } from '@/types'
import { Permission } from '@/types'

export const roles: Record<string, Role[]> = {
  's1': [
    {
      id: 'r1-admin', serverId: 's1', name: 'Admin', color: '#3ECFCF', position: 0,
      permissions: Object.values(Permission),
    },
    {
      id: 'r1-mod', serverId: 's1', name: 'Moderator', color: '#E8A840', position: 1,
      permissions: [
        Permission.ManageMessages, Permission.KickMembers,
        Permission.MuteMembers, Permission.ManageInvites,
        Permission.SendMessages, Permission.Connect, Permission.Speak,
      ],
    },
    {
      id: 'r1-member', serverId: 's1', name: 'Member', color: '#8B95A8', position: 2,
      permissions: [
        Permission.SendMessages, Permission.EmbedLinks, Permission.AttachFiles,
        Permission.Connect, Permission.Speak,
      ],
    },
  ],
  's2': [
    {
      id: 'r2-admin', serverId: 's2', name: 'Admin', color: '#E8A840', position: 0,
      permissions: Object.values(Permission),
    },
    {
      id: 'r2-member', serverId: 's2', name: 'Member', color: '#8B95A8', position: 1,
      permissions: [
        Permission.SendMessages, Permission.EmbedLinks, Permission.Connect, Permission.Speak,
      ],
    },
  ],
}

// channelId -> roleId[] mapping (which roles have access to which channels)
export const channelPermissions: Record<string, string[]> = {
  'ch1': ['r1-admin', 'r1-mod', 'r1-member'],
  'ch2': ['r1-admin', 'r1-mod'],
  'ch3': ['r1-admin', 'r1-mod', 'r1-member'],
  'ch5': ['r1-admin', 'r1-mod'],
  'ch18': ['r1-admin', 'r1-mod'],
}

// userId -> roleId mapping per server
export const memberRoles: Record<string, Record<string, string>> = {
  's1': {
    'u1': 'r1-admin',
    'u2': 'r1-mod',
    'u3': 'r1-member',
    'u4': 'r1-member',
    'u5': 'r1-member',
    'u7': 'r1-mod',
    'u8': 'r1-member',
  },
  's2': {
    'u2': 'r2-admin',
    'u7': 'r2-member',
  },
}
